export const REVIEW_SHOP_OPTIONS = [
    { key: 'permian', label: 'Permian (Carlsbad)' },
    { key: 'oklahoma', label: 'Oklahoma (Weatherford)' },
];
const REVIEW_SHOP_KEY_PATTERN = /^[a-z][a-z0-9_]{1,31}$/;
export function isReviewShopKey(value) {
    return typeof value === 'string' && REVIEW_SHOP_KEY_PATTERN.test(value);
}
export function normalizeReviewShopKey(value) {
    if (typeof value !== 'string')
        return null;
    const normalized = value.trim().toLowerCase();
    return isReviewShopKey(normalized) ? normalized : null;
}
export function getReviewShopLabel(value) {
    const key = normalizeReviewShopKey(value);
    return REVIEW_SHOP_OPTIONS.find((option) => option.key === key)?.label ?? null;
}
//# sourceMappingURL=review-shops.js.map